import {api, coordinator, routes} from "@/plugins/axios";
import {ref} from "vue";

export function useOrganizations() {
    const fetching = ref(false);

    const getOrganizationsByName = async (name, page, perPage) => {
        fetching.value = true;
        return coordinator.get(routes.organizations.search(name, page, perPage))
            .then(response => {
                return Promise.resolve(response.data);
            })
            .finally(() => {
                fetching.value = false;
            });
    }

    const getOrganizationBySlug = async (slug) => {
        fetching.value = true;
        return coordinator.get(routes.organizations.get(slug))
            .then(response => {
                return Promise.resolve(response.data);
            })
            .finally(() => {
                fetching.value = false
            });
    }

    const updateOrganizationInfo = (organizationSlug, data) => {
        return api.post(routes.organizations.updateInfo(organizationSlug), {
            name: data.name,
            color: data.color
        }).then((response) => {
            return Promise.resolve(response.data);
        }).catch((err) => {
            return Promise.reject(err);
        });
    }

    const uploadLogo = (organizationSlug, formData) => {
        return api.post(routes.organizations.uploadLogo(organizationSlug), formData).catch((err) => {
            return Promise.reject(err);
        });
    }

    const uploadCover = (organizationSlug, formData) => {
        return api.post(routes.organizations.uploadCover(organizationSlug), formData).catch((err) => {
            return Promise.reject(err);
        });
    }

    const deleteLogo = (organizationSlug) => {
        return api.delete(routes.organizations.deleteLogo(organizationSlug)).catch((err) => {
            return Promise.reject(err);
        });
    }

    const deleteCover = (organizationSlug) => {
        return api.delete(routes.organizations.deleteCover(organizationSlug)).catch((err) => {
            return Promise.reject(err);
        });
    }

    const getMembersListSettings = (organizationSlug) => {
        fetching.value = true;
        return coordinator.get(routes.organizations.getMembersListSettings(organizationSlug))
            .then(response => {
                return Promise.resolve(response.data);
            })
            .finally(() => {
                fetching.value = false;
            });
    }

    const updateMembersListSettings = (organizationSlug, settings) => {
        fetching.value = true;

        return coordinator.put(routes.organizations.updateMembersListSettings(organizationSlug), {settings})
            .then(response => {
                return Promise.resolve(response.data);
            })
            .catch(err => {
                return Promise.reject(err);
            })
            .finally(() => {
                fetching.value = false;
            });
    }

    const getMembersBeneficiaryPermission = async (organizationSlug) => {
        return coordinator
            .get(routes.organizations.getMembersBeneficiaryPermission(organizationSlug))
            .then((response) => {
                const accessLevel = response.data?.beneficiary_access_level || "0";
                return Promise.resolve({ value: accessLevel });
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };

    const patchMembersBeneficiaryPermission = async (organizationSlug, payload) => {
        return coordinator
            .post(routes.organizations.updateMembersBeneficiaryPermission(organizationSlug), payload)
            .then((response) => {
                const accessLevel = response.data?.beneficiary_access_level || "0";
                return Promise.resolve({ value: accessLevel });
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };

    return {
        getOrganizationsByName,
        getOrganizationBySlug,
        updateOrganizationInfo,
        uploadCover,
        uploadLogo,
        deleteCover,
        deleteLogo,
        getMembersListSettings,
        updateMembersListSettings,
        getMembersBeneficiaryPermission,
        patchMembersBeneficiaryPermission
    }
}
